import React, { useMemo, useState } from 'react'
import { Icon, Label, Popup } from 'semantic-ui-react'
import _ from 'lodash'

const PopupLabels = ({ items, title, currentValue, onClick }) => {

  const [isOpen, setIsOpen] = useState(false)

  const trigger = <Label
    size='tiny'
    style={{ margin: '.5em', cursor: 'pointer' }}
    color='blue'
    title={title}
    onClick={(e) => {
      setIsOpen(true)
    }}
  >
    {_.startCase(currentValue)}
    <Icon name='angle right' style={{ marginLeft: '1em' }} />
  </Label>

  const popup = useMemo(() => {

    const lbls = _.map(items, item => (
      <Label
        style={{ cursor: 'pointer' }}
        size='tiny'
        color={currentValue === item ? 'blue' : 'grey'}
        onClick={(e) => {
          onClick(item)
          setIsOpen(false)
        }}
      >
        {_.startCase(item)}
      </Label>))

    return <Popup
      content={<div style={{ display: 'flex', flexDirection: 'column', gap: '.5em', maxHeight: '30vh', overflowY: 'auto' }}>{lbls}</div>}
      on='click'
      pinned
      position='bottom left'
      basic
      size='tiny'
      style={{ backgroundColor: 'var(--off-black-4)', color: 'white', borderColor: 'var(--off-black-5)' }}
      trigger={trigger}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      closeOnDocumentClick
    />
  }, [items, currentValue, isOpen])

  return popup

}

export default PopupLabels